import { createLogger } from '@aviv-unified-frontend/runtime/monitoring';
const Logger = createLogger('app_pric');
export { Logger };
